import { TweenMax, TimelineMax, Power3, Circ } from 'gsap';

class Accordion {
  constructor() {
    this.accordionToggles = document.querySelectorAll('.accordion__toggle');
    this.timeline = new TimelineMax();
    this.isAnimating = false;
    this.initialize();
  }

  initialize() {
    const toggles = Array.from(this.accordionToggles);

    toggles.forEach((toggle, index) => {
      toggle.addEventListener('keydown', this.keydown.bind(this, index));
      toggle.addEventListener('click', this.toggleContent.bind(this));
    });
  }

  toggleContent(e) {
    const parent = e.currentTarget ? e.currentTarget.parentNode : e.target.parentNode;
    const content = parent.querySelector('.accordion__content');
    const inner = parent.querySelector('.accordion__inner');

    // animations and logic to toggle the accordion open/close state
    if (!this.isAnimating) {
      this.isAnimating = true;
      if (!parent.classList.contains('accordion--open')) {
        TweenMax.set(content, { height: 'auto' });
        this.timeline.from(content, 0.3, {
          height: 0,
          ease: Circ.easeOut,
        });
        this.timeline.to(
          inner,
          0.3,
          {
            autoAlpha: 1,
            ease: Power3.easeInOut,
            onComplete: () => {
              this.isAnimating = false;
              TweenMax.set(content, { height: 'auto' });
            },
          },
          '-=0.1',
        );
        parent.classList.add('accordion--open');
        if (e.type === 'click') {
          document.activeElement.blur();
        }
      } else {
        this.timeline.to(inner, 0.3, {
          autoAlpha: 0,
          ease: Power3.easeInOut,
        });
        this.timeline.to(
          content,
          0.3,
          {
            height: 0,
            ease: Circ.easeOut,
            onComplete: () => {
              TweenMax.set(inner, { clearProps: 'all' });
              this.isAnimating = false;
            },
          },
          '-=0.1',
        );
        parent.classList.remove('accordion--open');
        if (e.type === 'click') {
          document.activeElement.blur();
        }
      }
    }
  }

  keydown(index, e) {
    const KEY_ENTER = 13;
    const KEY_UP = 38;
    const KEY_DOWN = 40;

    const toggle = e.target;
    let accordionFocus = index;

    // Checks if accordion at given index is hidden
    const isAccordionHidden = index =>
      this.accordionToggles[index].parentNode.classList.contains('hide');

    switch (e.keyCode) {
      case KEY_ENTER:
        if (e.type === 'keypress') {
          this.toggleContent(e);
        }
        toggle.checked = !toggle.checked;
        break;

      case KEY_UP:
        // Prevent page from shifting
        e.preventDefault();
        // Move focus up to next visible accordion
        do {
          accordionFocus--;
          // If we're at the start, go to the end
          if (accordionFocus < 0) {
            accordionFocus = this.accordionToggles.length - 1;
          }
        } while (isAccordionHidden(accordionFocus));
        break;

      case KEY_DOWN:
        // Prevent page from shifting
        e.preventDefault();
        // Move focus down to next visible accordion
        do {
          accordionFocus++;
          // If we're at the end, go to the start
          if (accordionFocus >= this.accordionToggles.length) {
            accordionFocus = 0;
          }
        } while (isAccordionHidden(accordionFocus));
        break;

      default:
        break;
    }

    this.accordionToggles[accordionFocus].focus();
  }
}

export default Accordion;
